import { Component, inject, Signal } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { AdobeDataLayerService, GlobalLoaderService } from 'shared-data-access';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private globalLoaderService = inject(GlobalLoaderService);
  private adobeDataLayerService = inject(AdobeDataLayerService);
  private router = inject(Router);

  readonly loading: Signal<boolean> = this.globalLoaderService.loading;

  constructor() {
    this.router.events.pipe(filter((event: Event) => event instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.adobeDataLayerService.pushEvent('pageView', { pageName: e.urlAfterRedirects });
    });
  }
}
